import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';

export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);

    const [noteText, setNoteText] = useState('');
    const [location, setLocation] = useState('');
    const [name, setName] = useState('');
    const [codigo, setCodigo] = useState('');

    const [descuento, setDescuento] = useState(0);
    const [codigoValido, setCodigoValido] = useState(false);

    const [totalPrice, setTotalPrice] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('efectivo');
    const [deliveryOption, setDeliveryOption] = useState('delivery');

    const [contactos, setContactos] = useState([]);
    const [codigos, setCodigos] = useState([]);

    /* =========================
       CONTACTO
    ========================= */
    useEffect(() => {
        fetch(`${baseURL}/contactoGet.php`)
            .then(r => r.json())
            .then(data => {
                setContactos(data.contacto?.reverse()?.[0] || []);
            })
            .catch(() => {});
    }, []);

    /* =========================
       CODIGOS
    ========================= */
    useEffect(() => {
        fetch(`${baseURL}/codigosGet.php`)
            .then(r => r.json())
            .then(data => setCodigos(data.codigos || []))
            .catch(() => {});
    }, []);

    /* =========================
       PRODUCTOS (GLOBAL)
    ========================= */
    useEffect(() => {
        fetch(`${baseURL}/tiendasFrontend.php`)
            .then(res => res.json())
            .then(data => {
                const allProducts = data.tiendas.flatMap(t => t?.productos || []);
                setProductos(allProducts);
            })
            .catch(() => {});
    }, []);

    /* =========================
       CART FROM LOCALSTORAGE
    ========================= */
    const loadCart = () => {
        const cart = JSON.parse(localStorage.getItem('cart')) || [];

        // 🔥 IMPORTANTE: esperar productos
        if (!productos || productos.length === 0) {
            setCartItems([]);
            setLoading(false);
            return;
        }

        const items = cart
            .map(cartItem => {
                const product = productos.find(
                    p => p.idProducto === cartItem.idProducto
                );

                if (!product) return null;

                return {
                    ...product,
                    cantidad: cartItem.cantidad,
                    item: cartItem.item,
                    idTienda: cartItem.idTienda
                };
            })
            .filter(Boolean);

        setCartItems(items);
        setLoading(false);
    };

    useEffect(() => {
        loadCart();
    }, [productos]);

    /* =========================
       TOTAL
    ========================= */
    useEffect(() => {
        const total = cartItems.reduce(
            (acc, item) => acc + item.precio * item.cantidad,
            0
        );
        setTotalPrice(total);
    }, [cartItems]);

    /* =========================
       ACTIONS
    ========================= */
    const removeFromCart = (id) => {
        const updated = cartItems.filter(i => i.idProducto !== id);
        setCartItems(updated);
        localStorage.setItem('cart', JSON.stringify(updated));
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cart');
    };

    const increaseQuantity = (index) => {
        const updated = [...cartItems];
        updated[index].cantidad += 1;
        setCartItems(updated);
        localStorage.setItem('cart', JSON.stringify(updated));
    };

    const decreaseQuantity = (index) => {
        const updated = [...cartItems];
        if (updated[index].cantidad > 1) {
            updated[index].cantidad -= 1;
            setCartItems(updated);
            localStorage.setItem('cart', JSON.stringify(updated));
        }
    };

    /* =========================
       WHATSAPP
    ========================= */
    const handleWhatsappMessage = () => {
        const codigoDescuento = codigos.find(c => c.codigo === codigo);
        const descuentoActualizado = codigoDescuento ? codigoDescuento.descuento : 0;

        let total = cartItems.reduce(
            (acc, i) => acc + i.precio * i.cantidad,
            0
        );

        let finalTotal = total - descuentoActualizado;
        if (finalTotal < 0) finalTotal = 0;

        const formattedTotal = finalTotal
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        const phone = cartItems?.[0]?.telefono || '';

        const details = cartItems.map(item =>
            `\n✅ *${item.titulo}*
Cantidad: ${item.cantidad}
Precio: ${moneda} ${item.precio}`
        );

        const message = `
Hola 👋 quiero pedir:
${details.join('')}

Total: ${moneda} ${formattedTotal}
        `;

        window.open(
            `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`,
            '_blank'
        );
    };

    /* =========================
       UI
    ========================= */
    return (
        <div>
            <button onClick={() => setModalIsOpen(true)} className='cartIconFixed'>
                {cartItems?.length > 0 && <span>{cartItems.length}</span>}
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={() => setModalIsOpen(false)}
            >
                <div className='deFLex'>
                    <button onClick={() => setModalIsOpen(false)}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                    <button onClick={clearCart}>Vaciar carrito</button>
                </div>

                {loading ? (
                    <p>Cargando...</p>
                ) : cartItems.length === 0 ? (
                    <p>No hay productos</p>
                ) : (
                    <>
                        {cartItems.map((item, index) => (
                            <div key={item.idProducto} className='cardProductCart'>
                                <Anchor to={`/producto/${item.idProducto}/${item.titulo}`}>
                                    <img src={item.imagen1} alt="" />
                                </Anchor>

                                <div>
                                    <h3>{item.titulo}</h3>
                                    <strong>{moneda} {item.precio}</strong>
                                </div>

                                <div>
                                    <button onClick={() => removeFromCart(item.idProducto)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>

                                    <div>
                                        <button onClick={() => decreaseQuantity(index)}>-</button>
                                        <span>{item.cantidad}</span>
                                        <button onClick={() => increaseQuantity(index)}>+</button>
                                    </div>
                                </div>
                            </div>
                        ))}

                        <h4>Total: {moneda} {totalPrice}</h4>

                        <button onClick={handleWhatsappMessage} className='btnWpp'>
                            Pedir por WhatsApp <img src={whatsappIcon} />
                        </button>
                    </>
                )}
            </Modal>
        </div>
    );
}